import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditReservation() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [reservationsData, setReservationsData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/statuts_reservations?id=${id}&natures_investissement_id=${selectedCategorie?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setStatutData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/reservations/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const reservationsData = await response.json();
      setReservationsData(reservationsData);
      console.log(reservationsData);
      setSelectedPartenaire(
        reservationsData?.detail_reservation?.Réservation?.Partenaire
      );
      setSelectedInvestisseur(
        reservationsData?.detail_reservation?.Réservation?.Investisseur
      );
      setSelectedStatut(
        reservationsData?.detail_reservation?.Réservation?.Statut
      );
      setSelectedCategorie(
        reservationsData?.detail_reservation?.Réservation?.["Catégorie PME"]
      );
      setSelectedPme(
        reservationsData?.detail_reservation?.Réservation?.["PME (si connue)"]
      );
      setSelectedAnnee(
        reservationsData?.detail_reservation?.Réservation?.[
          "Année de souscription"
        ]
      );
      setSelectedTaux(
        reservationsData?.detail_reservation?.Réservation?.["Taux d'apport"]
      );
      setSelectedDateEngagement(
        reservationsData?.detail_reservation?.Réservation?.[
          "Date engagement ferme"
        ]
      );
      setSelectedDateLimite(
        reservationsData?.detail_reservation?.Réservation?.[
          "Date limite de confirmation"
        ]
      );
      setSelectedMontant(
        reservationsData?.detail_reservation?.Réservation?.["Montant (€)"]
      );
      setSelectedComplement(
        reservationsData?.detail_reservation?.Réservation?.[
          "Complément d'informations"
        ]
      );
      setSelectedDateSignature(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Date de signature"
        ]
      );
      setSelectedMode(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Mode de règlement"
        ]
      );
      setSelectedIban(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "IBAN"
        ]
      );
      setSelectedBic(
        reservationsData?.detail_reservation?.["Dossier de souscription"]["BIC"]
      );
      setSelectedRum(
        reservationsData?.detail_reservation?.["Dossier de souscription"]["RUM"]
      );
      setSelectedDatePrelevement(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Date de prélèvement"
        ]
      );
      setSelectedLieuSignature(
        reservationsData?.detail_reservation?.["Dossier de souscription"][
          "Lieu de signature"
        ]
      );
    } catch (error) {
      console.error(error);
    }
  };
  /************************* Partenaire *******************************/
  const [partenairesData, setPartenairesData] = useState({ data: [] });
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/partenaires?id=${id}&investisseur_id=${selectedInvestisseur?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setPartenairesData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenairesData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Partenaire *******************************/
  /*************************   Investisseurs  *******************************/
  const [investisseursData, setInvestisseursData] = useState({ data: [] });
  const [selectedInvestisseur, setSelectedInvestisseur] = useState("");
  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const getInvestisseurs = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/investisseurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setInvestisseursData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseursOptions = () => {
    return [
      {
        options: investisseursData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Investisseurs *******************************/
  /*************************   Catégorie PME  *******************************/
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const [categorieData, setCategorieData] = useState({ data: [] });
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  console.log(selectedCategorie);
  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((categorie) => {
          setCategorieData(categorie);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/pmes?id=${id}&natures_investissement_id=${selectedCategorie?.value}&pme_id=${selectedPme?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Année   *******************************/
  const [selectedAnnee, setSelectedAnnee] = useState("");
  const [anneeData, setAnneeData] = useState({ data: [] });
  const handleAnneeChange = (e) => {
    setSelectedAnnee(e);
  };
  const getAnnee = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/annees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setAnneeData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAnneeOptions = () => {
    return [
      {
        options: anneeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Année *******************************/
  /*************************   Taux d'apport  *******************************/
  const [selectedTaux, setSelectedTaux] = useState("");
  const [tauxData, setSelectedTauxData] = useState({ data: [] });
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/taux_apports?id=${id}&investisseur_id=${selectedInvestisseur?.value}&taux_apport_id=${selectedTaux.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Montant *******************************/
  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };

  /*************************   END Montant  *******************************/
  /*************************   Date d'engagement et limite *******************************/
  const [selectedDateEngagement, setSelectedDateEngagement] = useState("");
  const [selectedDateLimite, setSelectedDateLimite] = useState("");

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedComplement, setSelectedComplement] = useState("");
  const handleComplementChange = (e) => {
    setSelectedComplement(e.target.value);
  };
  /************************* END Complément   *******************************/

  /******************************* Date de signature *******************************************/
  const [selectedDateSignature, setSelectedDateSignature] = useState("");
  /******************************* END date de signature *******************************************/
  /******************************* Lieu de signature *******************************************/
  const [selectedLieuSignature, setSelectedLieuSignature] = useState("");
  const handleLieuChange = (e) => {
    setSelectedLieuSignature(e.target.value);
  };
  /******************************* END Lieu *******************************************/
  /******************************* Mode de règlement *******************************************/
  const [selectedMode, setSelectedMode] = useState("");
  const [modeData, setModeData] = useState({ data: [] });
  const handleModeChange = (e) => {
    setSelectedMode(e);
  };

  const getMode = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations/mode_reglements?id=${id}&mode_reglement_id=${selectedMode?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setModeData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeOptions = () => {
    return [
      {
        options: modeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Mode de règlement *******************************************/
  /******************************* IBAN *******************************************/
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  /******************************* END IBAN *******************************************/
  /******************************* BIC *******************************************/
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /******************************* END BIC *******************************************/
  /******************************* RUM *******************************************/
  const [selectedRum, setSelectedRum] = useState("");
  const handleRumChange = (e) => {
    setSelectedRum(e.target.value);
  };
  /******************************* END RUM *******************************************/
  /******************************* Date prelevement *******************************************/
  const [selectedDatePrelevement, setSelectedDatePrelevement] = useState("");
  const handleDatePrelevementChange = (e) => {
    setSelectedDatePrelevement(e.target.value);
  };
  /******************************* END Date prelevement *******************************************/
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedPartenaire === null &&
      selectedStatut === null &&
      selectedTaux === null &&
      selectedAnnee === null
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else if (selectedPartenaire === null && selectedStatut === null) {
      toast.error("Le statut et le partenaire ne peuvent pas être vide");
    } else if (selectedTaux === null) {
      toast.error("Le taux ne peut pas être vide");
    } else if (selectedAnnee === null) {
      toast.error("L'année ne peut pas être vide");
    } else if (selectedPartenaire === null) {
      toast.error("Le partenaire ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/reservations/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              reservation: {
                id: id,
                partenaire_id: selectedPartenaire?.value || "",
                investisseur_id: selectedInvestisseur?.value || "",
                natures_investissement_id: selectedCategorie?.value || "",
                montant: selectedMontant,
                statuts_reservation_id: selectedStatut?.value || "",
                date_limite_confirmation: selectedDateLimite,
                date_engagement_ferme: selectedDateEngagement,
                taux_apport_id: selectedTaux?.value || "",
                pme_id: selectedPme?.value || "",
                annee_id: selectedAnnee?.value || "",
                complement_dinformations: selectedComplement,
                lieu_de_signature: selectedLieuSignature,
                date_de_signature: selectedDateSignature,
                mode_reglement_id: selectedMode?.value || "",
                iban: selectedIban,
                bic: selectedBic,
                rum: selectedRum,
                date_prelevement: selectedDatePrelevement,
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          const responseData = await response.json();
          // localStorage.setItem("key", true);
          // localStorage.setItem("lastId", id);

          navigate(`${backUrl}${responseData.go_to}`);
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.reservation_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors = responseData?.reservation_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  useEffect(() => {
    if (!loading) {
      getMode();
      getPartenaire();
      getStatut();
      getTaux();
      getAnnee();
      getInvestisseurs();
      getPme();
      getCategories();
    }
  }, [loading]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Réservations | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    console.log(selectedMode);
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails réservation
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/reservations/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Réservations
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          reservationsData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    {" "}
                                    Réservation
                                  </CardTitle>
                                  <CardBody>
                                    {Object.entries(
                                      reservationsData?.detail_reservation
                                        ?.Réservation
                                    ).map(([key, value], index) => (
                                      <Row className="mb-2" key={index}>
                                        {key === "Statut" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedStatut?.label == null
                                                    ? null
                                                    : selectedStatut
                                                }
                                                onChange={handleStatutChange}
                                                options={renderStatutOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                              {selectedStatut === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Statut ne peut pas être vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Partenaire" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedPartenaire?.label ==
                                                  null
                                                    ? null
                                                    : selectedPartenaire
                                                }
                                                onChange={
                                                  handlePartenaireChange
                                                }
                                                options={renderPartenaireOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                              {selectedPartenaire === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Partenaire ne peut pas être
                                                  vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Catégorie PME" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedCategorie?.label ==
                                                  null
                                                    ? null
                                                    : selectedCategorie
                                                }
                                                onChange={handleCategorieChange}
                                                options={renderCategorieOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key === "PME (si connue)" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedPme?.label == null
                                                    ? null
                                                    : selectedPme
                                                }
                                                onChange={handlePmeChange}
                                                options={renderPmeOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key === "Investisseur" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedInvestisseur?.label ==
                                                  null
                                                    ? null
                                                    : selectedInvestisseur
                                                }
                                                onChange={
                                                  handleInvestisseurChange
                                                }
                                                options={renderInvestisseursOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key === "Année de souscription" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedAnnee?.label == null
                                                    ? null
                                                    : selectedAnnee
                                                }
                                                onChange={handleAnneeChange}
                                                options={renderAnneeOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                              {selectedAnnee === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Année de souscription ne peut
                                                  pas être vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Taux d'apport" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedTaux?.label == null
                                                    ? null
                                                    : selectedTaux
                                                }
                                                onChange={handleTauxChange}
                                                options={renderTauxOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                              {selectedTaux === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Taux d'apport ne peut pas être
                                                  vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Montant (€)" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <input
                                                className="form-control form-control-sm"
                                                defaultValue={selectedMontant
                                                  .toLocaleString("fr-FR", {
                                                    style: "currency",
                                                    currency: "EUR",
                                                  })
                                                  .replace("€", "")}
                                                required
                                                onChange={handleMontantChange}
                                              />
                                            </Col>
                                          </>
                                        ) : key === "Date engagement ferme" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateEngagement}
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateEngagement(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>
                                        ) : key ===
                                          "Date limite de confirmation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <InputMask
                                                mask="99/99/9999"
                                                value={selectedDateLimite}
                                                className="form-control form-control-sm input-color"
                                                onChange={(dateString) => {
                                                  setSelectedDateLimite(
                                                    dateString.target.value
                                                  );
                                                }}
                                              />
                                            </Col>
                                          </>
                                        ) : key ===
                                          "Complément d'informations" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <textarea
                                                className="form-control form-control-sm"
                                                defaultValue={
                                                  selectedComplement
                                                }
                                                style={{
                                                  width: "100%",
                                                  resize: "vertical",
                                                }}
                                                onChange={
                                                  handleComplementChange
                                                }
                                              ></textarea>
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Row>
                                  <SouscriptionsCard
                                    title="Cumuls"
                                    details={
                                      reservationsData?.detail_reservation
                                        ?.Cumuls
                                    }
                                  />
                                </Row>
                                <Col sm="12">
                                  <Row>
                                    <Card className="mb-4">
                                      <CardTitle tag="h5">
                                        Dossier de souscription
                                      </CardTitle>
                                      <CardBody>
                                        {Object.entries(
                                          reservationsData
                                            ?.detail_reservation?.[
                                            "Dossier de souscription"
                                          ]
                                        ).map(([key], index) => (
                                          <Row key={index} className="mb-2">
                                            {key == "IBAN" &&
                                            selectedMode?.value === 3 ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>
                                                      {key || "IBAN"} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  className="col-md-6"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={selectedIban}
                                                    required
                                                    onChange={handleIbanChange}
                                                  />
                                                </Col>
                                              </>
                                            ) : key == "Lieu de signature" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  className="col-md-6"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedLieuSignature
                                                    }
                                                    required
                                                    onChange={handleLieuChange}
                                                  />
                                                </Col>
                                              </>
                                            ) : key == "BIC" &&
                                              selectedMode?.value == 3 ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  className="col-md-6"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={selectedBic}
                                                    required
                                                    onChange={handleBicChange}
                                                  />
                                                </Col>
                                              </>
                                            ) : key == "RUM" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  className="col-md-6"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={selectedRum}
                                                    required
                                                    onChange={handleRumChange}
                                                  />
                                                </Col>
                                              </>
                                            ) : key == "Mode de règlement" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key}* :</span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedMode?.label ==
                                                      null
                                                        ? null
                                                        : selectedMode
                                                    }
                                                    onChange={handleModeChange}
                                                    options={renderModeOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                    styles={styles(false)}
                                                  />
                                                  {selectedMode === null ? (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Mode de règlement ne peut
                                                      pas être vide
                                                    </div>
                                                  ) : (
                                                    ""
                                                  )}
                                                </Col>
                                              </>
                                            ) : key == "Date de signature" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span>{key} :</span>
                                                  </i>
                                                </Col>
                                                <Col
                                                  className="col-md-6"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <InputMask
                                                    mask="99/99/9999"
                                                    value={
                                                      selectedDateSignature
                                                    }
                                                    className="form-control form-control-sm input-color"
                                                    onChange={(dateString) => {
                                                      setSelectedDateSignature(
                                                        dateString.target.value
                                                      );
                                                    }}
                                                  />
                                                </Col>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </Row>
                                        ))}
                                        {Object.keys(
                                          reservationsData
                                            ?.detail_reservation?.[
                                            "Dossier de souscription"
                                          ]
                                        ).includes("Date de prélèvement") ==
                                          false && selectedMode?.value == 3 ? (
                                          <>
                                            <Row className="mb-3">
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>
                                                    Date de prélèvement :
                                                  </span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={
                                                    selectedDatePrelevement
                                                  }
                                                  className="form-control form-control-sm input-color"
                                                  onChange={
                                                    handleDatePrelevementChange
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          </>
                                        ) : null}
                                        {Object.keys(
                                          reservationsData
                                            ?.detail_reservation?.[
                                            "Dossier de souscription"
                                          ]
                                        ).includes("IBAN") == false &&
                                        selectedMode?.value === 3 ? (
                                          <Row>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>IBAN :</span>
                                              </i>
                                            </Col>
                                            <Col
                                              className="col-md-6"
                                              style={{ textAlign: "right" }}
                                            >
                                              <input
                                                className="form-control form-control-sm"
                                                defaultValue={selectedIban}
                                                required
                                                onChange={handleIbanChange}
                                              />
                                            </Col>

                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>BIC :</span>
                                              </i>
                                            </Col>
                                            <Col
                                              className="col-md-6"
                                              style={{
                                                textAlign: "right",
                                                paddingTop: "15px",
                                              }}
                                            >
                                              <input
                                                className="form-control form-control-sm"
                                                defaultValue={selectedBic}
                                                required
                                                onChange={handleBicChange}
                                              />
                                            </Col>
                                          </Row>
                                        ) : null}
                                      </CardBody>
                                    </Card>
                                  </Row>
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditReservation;
